import { useRoute, useRouter } from 'vue-router'

import Network from '@/Network'
import { useErrorToast } from '@/composables/useErrorToast'
import type { DSAttendanceStatus } from '@/constants/ds-attendance.constants'

import { routeNameForStatus } from '../utils/status-route-map'

/**
 * "Enviar registro" do card novo: a mesma tela do "Ver detalhes" da aba velha (a de
 * aguardando envio do container), com os filtros da aba na query para a volta cair no
 * mesmo recorte. Mesma navegação do `handleDetails` do `Index.vue`.
 */
export function useOpenAttendanceContainer() {
  const route = useRoute()
  const router = useRouter()
  const { notifyError } = useErrorToast()

  async function openContainer(containerId: number, status: string): Promise<void> {
    const routeName = routeNameForStatus(status as DSAttendanceStatus)
    if (!routeName) return
    try {
      const details = await Network.dsAttendance.getById(containerId)
      await router.push({
        name: routeName,
        params: { attendanceId: String(containerId) },
        query: { ...route.query },
        state: { details: JSON.parse(JSON.stringify(details)), status }
      })
    } catch (error) {
      notifyError(error, 'Não foi possível abrir a solicitação.')
    }
  }

  return { openContainer }
}
